import { Charts } from './Charts';
import RegulationChartsDataProvider from './contexts/RegulationChartsDataContext';

const RegulationWrapper = () => {
    return (
        <RegulationChartsDataProvider>
            <Charts />
        </RegulationChartsDataProvider>
    );
};

export default RegulationWrapper;
